import styled from 'styled-components';
import { ControlButton, ControlButtonProps } from '@xyflow/react';

export const StyledControlButton = styled(ControlButton)<
	ControlButtonProps & { withbackground?: boolean }
>`
	&.react-flow__controls-button {
		height: 56px;
		width: 56px;
		border-radius: 0;
		border: none;
		border-color: ${({ theme }) => theme.v3.colors.gray[2]};
		border-bottom-color: ${({ theme }) => theme.v3.colors.gray[2]} !important;

		${({ withbackground, theme }) =>
			withbackground ? `background: ${theme.v3.colors.gray[0]}` : ''};

		svg {
			max-width: unset;
			max-height: unset;
		}
	}
`;
